/**
 * Features — template-style minimal grid: numbered, uppercase kickers,
 * tracking-tight headings, generous whitespace. Monochrome.
 */
const FEATURES = [
  {
    n: "01",
    title: "The Daily Verse, given, not displayed",
    body:
      "Each morning a word is prepared for you. Receive it, sit with a reflection written for your day, and carry it with you.",
  },
  {
    n: "02",
    title: "Your Faith Vine",
    body:
      "Watch your walk take root: a living vine that grows with every day you show up. Grace is built in. Pause it, set your own rhythm, never lose it to one hard week.",
  },
  {
    n: "03",
    title: "Prayer circles",
    body:
      "Walk with your people. Small groups with shared rhythms, gentle encouragement, and invites that work in any group chat.",
  },
  {
    n: "04",
    title: "The nine Fruits of the Spirit",
    body:
      "Love, joy, peace, patience, kindness, goodness, faithfulness, gentleness, self-control. Practice one each day and watch the pattern of your growth.",
  },
];

export function FeaturesSection() {
  return (
    <section id="features" className="bg-[#FAFAF7] px-6 py-24 md:px-12 md:py-32 lg:px-20">
      <p className="text-xs uppercase tracking-widest text-neutral-400">What it does</p>
      <h2 className="mt-4 max-w-3xl text-5xl font-medium leading-[1.02] tracking-tighter text-neutral-900 md:text-6xl">
        Built to grow faith,
        <br />
        not screen time.
      </h2>

      <div className="mt-20 grid grid-cols-1 gap-x-12 gap-y-16 md:grid-cols-2">
        {FEATURES.map((f) => (
          <div key={f.n} className="border-t border-neutral-200 pt-8">
            <p className="text-xs uppercase tracking-widest text-neutral-400">{f.n}</p>
            <h3 className="mt-4 text-2xl font-medium tracking-tight text-neutral-900 md:text-3xl">{f.title}</h3>
            <p className="mt-4 max-w-md leading-relaxed text-neutral-500">{f.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
